import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner,
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

export interface OfficesConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  danger?: boolean;
  isProcessing?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Confirmación de acciones destructivas o con efecto visible (eliminar, deshabilitar, llamado de prueba). */
const OfficesConfirmDialog = ({ open, title, message, confirmLabel, danger, isProcessing, onConfirm, onCancel }: OfficesConfirmDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} modalType="alert" onOpenChange={(_, d) => !d.open && !isProcessing && onCancel()}>
      <DialogSurface aria-describedby="offices-confirm-message">
        <DialogBody>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent id="offices-confirm-message">{message}</DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onCancel} disabled={isProcessing}>
              {t('Offices.actions.cancel')}
            </Button>
            <Button
              appearance="primary"
              onClick={onConfirm}
              disabled={isProcessing}
              icon={isProcessing ? <Spinner size="tiny" /> : undefined}
              data-danger={danger ? 'true' : undefined}
              data-testid="confirm-action"
            >
              {confirmLabel}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default OfficesConfirmDialog;
